// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2DuTX","messages":"Chat_messages__13Yv_","dateDivider":"Chat_dateDivider__3OLgj"};